export default __webpack_public_path__ + "static/media/quiz_career.9b7aae06.svg";